import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  role: () => import("/app/src/middleware/role.ts"),
  auth: () => import("/app/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/auth.js")
}